import api from './api';

export const notificationService = {
    // Sistem bildirimi gönder
    sendSystemNotification: async (notificationData) => {
        const response = await api.post('/admin/system-notifications', notificationData);
        return response.data;
    },

    // Tüm bildirimleri getir
    getAllNotifications: async (page = 1, limit = 20, filters = {}) => {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
            ...filters
        });

        const response = await api.get(`/admin/system-notifications?${params}`);
        return response.data;
    },

    // Bildirim detayını getir
    getNotificationDetail: async (notificationId) => {
        const response = await api.get(`/admin/system-notifications/${notificationId}`);
        return response.data;
    },

    // Bildirimi sil
    deleteNotification: async (notificationId) => {
        const response = await api.delete(`/admin/system-notifications/${notificationId}`);
        return response.data;
    },

    // Bildirim istatistiklerini getir
    getNotificationStats: async () => {
        const response = await api.get('/admin/system-notifications/stats');
        return response.data;
    },

    // Planlanmış bildirimleri getir
    getScheduledNotifications: async () => {
        const response = await api.get('/admin/system-notifications/scheduled');
        return response.data;
    }
};